<template>
  <div class="page">
    <p class="p1">
      套餐详情
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="content-class">
      <div class="nr1-class">
        <div class="nr1div-class">
          <span>套餐名：</span>
          <span class="span-nr">{{enjoyData.productName}}</span>
        </div>
        <div class="nr1div-class">
          <span>有效期：</span>
          <span class="span-nr">{{enjoyData.validTime}}</span>
        </div>
        <div class="nr1div-class">
          <span>网络状态：</span>
          <span class="span-nr">{{enjoyData.speedStatus}}</span>
        </div>
        <div class="wenxin">
          <p class="p1-class">套餐说明：</p>
          <p class="p2">{{enjoyData.description}}</p>
        </div>
      </div>
      <p class="kong"></p>

      <div class="nr2-class" v-if="overlayPackage.length">
        <ul>
          <li v-for="(item,index) in overlayPackage" :key="index" class="li_class">
            <p>
              <span>{{item.productName}}</span>
              <span>{{item.endTime}}</span>
            </p>
            <p>
              <span>
                <span>已用：{{item.useFlow}}</span> ~ <span>总量：{{item.monthFlow}}</span>
              </span>
              <span>{{item.orderNum}}</span>
            </p>
          </li>
        </ul>
      </div>
      <p class="kong"></p>

      <div class="nr3-class">
        <ul class="nr3-class-ul">
          <li :class="{selectClass:cardIndex === index}" @click="payDetails(item,index)" v-for="(item,index) in packageData" :key="index">
            <p>
              <span class="span1">{{item.productName}}</span>
              <span class="span4">¥{{item.price}}</span>
            </p>
            <p>
              <span class="span2">{{item.remark}}</span>
              <span class="span3">¥{{item.showPrice}}</span>
            </p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 底部立即充值 -->
    <div class="footer">
      <nut-button @click="pay">订单确认</nut-button>
    </div>
  </div>
</template>

<script>
import { wx_cardProductDetail } from "@/api/api.js"; //畅想套餐的使用详情
import { wx_speedProductUsed } from "@/api/api.js"; //畅想套餐叠加包的使用详情
import { wx_speedProduct } from "@/api/api.js"; //畅想套餐叠加包的套餐列表

export default {
  data() {
    return {
      enjoyData:{},
      overlayPackage:[],
      packageData:[],
      cardIndex:0,
      propsParams:{}
    }
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    // 获取订单
    initData(){
      // 获取畅想套餐的详情
      let params ={
        id:this.$route.query.id
      };
      wx_cardProductDetail(params).then(res=>{
        if(res.data.code == 200){
          this.enjoyData = res.data.data;
          this.enjoyData.speedStatus = this.enjoyData.speedStatus == "0" ?"4G速度":"2G速度";
        }
      });
      // 获取加油包的使用情况
      let overlayParams ={
        cardProductId:this.$route.query.id
      };
      wx_speedProductUsed(overlayParams).then(res=>{
        if(res.data.code == 200){
          this.overlayPackage = res.data.data;
        }
      });
      // 获取加油包的套餐列表
      let iccidParams ={
        iccid:this.$route.query.iccid
      };
      wx_speedProduct(iccidParams).then(res=>{
        if(res.data.code == 200){
          this.packageData = res.data.data;
          if(this.packageData.length > 0){
            this.propsParams = res.data.data[0]
          }
        }
      });
    },
    // 切换列表
    payDetails(val,index){
      this.cardIndex = index;
      this.propsParams = val
    },
    // 判断是否是微信浏览器
    isWeiXin() {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    // 去充值 
    pay(){
      if(this.enjoyData.speedStatus == "4G速度"){
        return this.$toast.fail("此卡当前状态无法购买加速包！");
      }else{
        if(this.isWeiXin()){
          sessionStorage.setItem('wechatId',this.enjoyData.appid);
          sessionStorage.setItem('iccid',this.$route.query.iccid);
          sessionStorage.setItem('id',this.propsParams.productId);
          sessionStorage.setItem('type','4');
          sessionStorage.setItem('packageId',this.$route.query.id);
          const url = "http://" + window.location.host +  "/dist/#/orderConfirm";
          const callbackURL = encodeURIComponent(url);
          const wechatId = this.enjoyData.appid;
          const redirectURI = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatId}&redirect_uri=${callbackURL}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`;
          location.replace(redirectURI);
        }else{
          this.$router.push({
            name: "orderConfirm",
            query: {
              iccid: this.$route.query.iccid,
              id:this.propsParams.productId,
              type:4,
              packageId:this.$route.query.id
            }
          });
        }
      }
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    window.document.title = "套餐详情";
  },
};
</script>
<style scoped lang="less">
  .page{
    .selectClass{
      border: 3px solid red !important;
    }
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
    }
    .rt-pos{
      position: absolute;
      left: 20px;
      top:14px;
      width: 12px;
      height: 12px;
      border-top: 2px solid gainsboro;
      border-left: 2px solid gainsboro;
      transform: rotate(-45deg);
    }
    .content-class{
      .nr1-class{
        padding: 10px;
        font-size: 14px;
        .nr1div-class{
          padding: 2px;
          display: flex;
          justify-content: space-between;
          span{
            margin-top: 5px;
          }
          .span-nr{
            color:#F94040;
          }
        }
        .wenxin{
          margin-top: 4px;
          padding: 2px;
          .p1-class{
            font-size: 14px;
          }
          .p2{
            margin-top: 3px;
            white-space: pre-wrap;
            font-size: 12px;
          }
        }
      }
      .kong{
        width: 100%;
        height: 15px;
        background: #ededed;
      }
      .nr2-class{
        padding: 10px;
        font-size: 13px;
        .li_class{
          border-bottom: 2px solid #ededed;
          height: 60px;
          p{
            display: flex;
            justify-content: space-between;
            padding: 3px;
          }
        }
      }
    }
    .nr3-class{
      padding: 10px;
      height: 180px;
      .nr3-class-ul{
        padding-bottom: 75px;
        box-sizing: border-box;
        li{
          margin-top: 5px;
          border: 3px solid #EDEDED;
          border-radius: 8px;
          p{
            padding: 10px;
            display: flex;
            justify-content: space-between;
            .span1{
              font-size: 16px;
              font-weight: 700;
            }
            .span4{
              font-size: 26px;
              color: #f94040;
            }
            .span2{
              display: inline-block;
              width: 75%;
            }
            .span3{
              text-decoration: line-through;
            }
          }
        }
      }
    }
    .footer{
      background: #F8F8F8;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      padding: 15px 0;
      button{
        border-radius: 10px;
        width: 52%;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
      }
    }
  }

</style>

